import * as types from '../mutation-types'
// import { ajaxFun } from '../actions'

// initial state
const state = {
  all: {},
  flag: false,
  time: '',
  stuAll: {},
  stuFlag: false,
  stuTime: ''
}

// getters
const getters = {
  vuexHomework: state => state
}

// actions
const actions = {
  // 作业
  receiveHomeworkList ({ commit }, homeworkList) {
    commit(types.RECEIVE_HOMEWORK_LIST, homeworkList)
  },

  receiveStudentHomeworkList ({ commit }, homeworkList) {
    commit(types.RECEIVE_STUDENT_HOMEWORK_LIST, homeworkList)
  },

  addToHomeworkList ({ commit }, homework) {
    commit(types.ADD_TO_HOMEWORK_LIST, homework)
  },

  clearHomework ({ commit }) {
    commit(types.CLEAR_HOMEWORK)
  },

  clearStudentHomework ({ commit }) {
    commit(types.CLEAR_STUDENT_HOMEWORK)
  },

  deleteHomework ({ commit, state }, homeworkId) {
    commit(types.DELETE_HOMEWORK, homeworkId)
  },

  updateHomeworkRed ({ commit }, para) {
    commit(types.UPDATE_HOMEWORK_RED, para)
  },

  updateHomeworkState ({ commit }, para) {
    commit(types.UPDATE_HOMEWORK_STATE, para)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_HOMEWORK_LIST] (state, homeworkList) {
    state.all = homeworkList
    state.flag = true
    state.time = new Date().getTime()
  },

  [types.RECEIVE_STUDENT_HOMEWORK_LIST] (state, homeworkList) {
    state.stuAll = homeworkList
    state.stuFlag = true
    state.stuTime = new Date().getTime()
  },

  // 由于列表需要分组后的作业信息，暂时放弃该方法
  // 缓存是当天的作业列表，直接添加，否则刷新列表为当天作业列表，查看学生的直接更新缓存
  [types.ADD_TO_HOMEWORK_LIST] (state, homework) {
    if (state.all.para) {
      if (state.all.para.dateString == '今日作业') {
        state.all.list.push(homework)
      } else {
        state.flag = false
      }
    }
    state.stuFlag = false
  },

  [types.CLEAR_HOMEWORK] (state) {
    state.flag = false
  },

  [types.CLEAR_STUDENT_HOMEWORK] (state) {
    state.stuFlag = false
  },

  [types.DELETE_HOMEWORK] (state, homeworkId) {
    if (state.all.list) {
      for (let i = 0; i < state.all.list.length; i++) {
        if (state.all.list[i].homeWorkId == homeworkId) {
          state.all.list.splice(i, 1)
        }
      }
    }

    if (state.stuAll.list) {
      for (let i = 0; i < state.stuAll.list.length; i++) {
        if (state.stuAll.list[i].homeWorkId == homeworkId) {
          state.stuAll.list.splice(i, 1)
          break
        }
      }
    }
  },

  // 更新作业红点状态
  [types.UPDATE_HOMEWORK_RED] (state, para) {
    let homeworkId = para.homeworkId
    let field1 = para.field1

    if (state.all.list) {
      for (let i = 0; i < state.all.list.length; i++) {
        if (state.all.list[i].homeWorkId == homeworkId) {
          state.all.list[i].field1 = field1
        }
      }
    }

    if (state.stuAll.list) {
      for (let i = 0; i < state.stuAll.list.length; i++) {
        if (state.stuAll.list[i].homeWorkId == homeworkId) {
          state.stuAll.list[i].field1 = field1
          break
        }
      }
    }
  },

  // 更新作业0:未读，1：已读，3：已反馈状态
  [types.UPDATE_HOMEWORK_STATE] (state, para) {
    let homeworkId = para.homeworkId
    let homeworkState = para.state

    if (state.all.list) {
      for (let i = 0; i < state.all.list.length; i++) {
        if (state.all.list[i].homeWorkId == homeworkId) {
          state.all.list[i].state = homeworkState
        }
      }
    }

    if (state.stuAll.list) {
      for (let i = 0; i < state.stuAll.list.length; i++) {
        if (state.stuAll.list[i].homeWorkId == homeworkId) {
          state.stuAll.list[i].state = homeworkState
          break
        }
      }
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/homework.js